<template>
  <article class="minhaconta__body digitalSignature" v-if="loaded">
    <p class="section__description">
      Tire uma foto da sua assinatura, com carimbo se preferir.
      Todos documentos emitidos serão gerados com sua assinatura digitalizada.
    </p>

    <div class="crop__wrapper">
      <croppa
        v-model="signature"
        @image-remove="imgLoaded = false; initialImage = null; $refs.croppa.refresh()"
        @new-image="checkSize"
        :placeholder-font-size="14"
        :show-remove-button="false"
        :ref="'croppa'"
        :disabled="disableCroppa"
        :quality="1"
        :zoom-speed="40"
        :width="400"
        :height="200"
        :key="restart"
        class="text-center crop__component"
        placeholder="Clique ou arraste a imagem aqui para adicionar"
        canvas-color="#fff"
      >
        <transition name="fade" v-if="imgLoaded && !disableCroppa">
          <div class="crop__remove">
            <button
              v-if="!initialImage"
              @click="clearImage()"
              class="btn btn-action s-circle crop__remove-btn">
              <i class="icon icon-cross"></i>
            </button>
          </div>
        </transition>

        <img slot="initial" :src="initialImage" v-if="initialImage" />

        <transition name="fade">
          <div class="commands">

            <div class="crop__zoom">
              <div class="crop__zoom-in">
                <button
                  v-if="!initialImage"
                  @mousedown="$refs.croppa.zoomIn()"
                  class="btn btn-action s-circle crop__zoom-in-btn">
                  <i class="icon icon-plus"></i>
                </button>
              </div>

              <div class="crop__zoom-out">
                <button
                  v-if="!initialImage"
                  @mousedown="$refs.croppa.zoomOut()"
                  class="btn btn-action s-circle crop__zoom-out-btn">
                  <i class="icon icon-minus"></i>
                </button>
              </div>
            </div>

            <button
              @click="clearImage()"
              class="btn btn-sm btn-blue"
            >
              Adicionar nova assinatura
            </button>
          </div>
        </transition>
      </croppa>
    </div>

    <dr-submit
      @click.native="send()"
      :disabled="!imgLoaded || initialImage"
      :sending="sending"
      text="Enviar assinatura"
      class="digitalSignature__submit"
    />
  </article>
</template>

<script>
import Croppa from 'vue-croppa'
import drSubmit from '@/components/form/submit'

export default {
  components: {
    'croppa': Croppa.component,
    drSubmit
  },
  data () {
    return {
      restart: 0,
      loaded: false,
      initialImage: null,
      signature: null,
      imgLoaded: false,
      sending: false,
      mouseEv: null,
      disableCroppa: false,
      crossOrigin: null,
      cropWidth: 0
    }
  },
  computed: {
    isTablet () {
      return this.windowWidth <= 740
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    this.$http.get(`/doctor/signature_picture`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.loaded = true
        if (res.data) {
          /*
          |-----------------------------------------------------------------------------
          | ! THIS IS A HOT FIX, A BETTER SOLUTION MUST BE IMPLEMENTED
          |-----------------------------------------------------------------------------
          |
          | In this case, res.data is, for instance, "/doctor/42/signature_picture/5eb0ca8aa8a66859801829.png",
          | but only "/doctor/42/signature_picture" is necessary. This sould be fixed in API.
          |
          | The glue code below removes the file name from the string based.
          */

          const sufix = res.data.slice(0, res.data.length - 27)
          this.initialImage = this.API_URL + '/s3/file' + sufix
          this.imgLoaded = true
        }
        this.fn_HIDE_PROGRESS()
      }
    ).catch(
      (err) => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
        console.log(err)
      }
    )

    this.cropWidth = document.querySelectorAll('.crop__wrapper')[0]
      ? document.querySelectorAll('.crop__wrapper').offsetWidth
      : null
  },
  methods: {
    setInterval (f, time) {
      return setInterval(f, time)
    },
    clearInterval (id) {
      return clearInterval(id)
    },
    clearImage () {
      const self = this
      this.initialImage = false
      this.disableCroppa = false
      this.$refs.croppa.remove()
      setTimeout(function () { // hack para CORS no firefox (e possivelmente outros)
        self.$refs.croppa.refresh()
        self.restart = self.restart + 1
      }, 100)
    },
    checkSize (ev) {
      // console.log(ev)
      // console.log(this.$refs.croppa)
      // console.log(this.$refs.croppa.naturalWidth, this.$refs.croppa.naturalHeight)
      // console.log(this.$refs.croppa.img.width)
      if (this.$refs.croppa.img.width < 400 || this.$refs.croppa.img.height < 200) {
        const self = this
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'A imagem enviada é muito pequena.<br>Envie uma imagem com melhor resolução (no mínimo 400px de largura por 200px de altura).',
          size: 'md',
          active: true,
          callback: function () {
            self.$refs.croppa.refresh()
          }
        })
        this.imgLoaded = false
        return
      }
      this.crossOrigin = 'anonymous'
      this.imgLoaded = true
    },
    send () {
      this.disableCroppa = true
      this.sending = true
      this.fn_SHOW_PROGRESS()
      console.log(this.$refs.croppa)
      // this.$refs.croppa.img.setAttribute('crossOrigin', 'anonymous')
      this.$refs.croppa.generateBlob((blob) => {
        function getFormData (object) {
          const formData = new FormData()
          Object.keys(object).forEach(key => formData.append(key, object[key]))
          return formData
        }

        let headers = this.fn_COPY_OBJECT(this.$store.getters.getAuthHeader)
        let boundary = Math.random().toString().substr(2)
        headers.headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
        blob.lastModifiedDate = new Date()
        blob.name = 'assinatura'
        let data = {'signature_picture[signaturePictureFile][file]': blob}
        let fdata = getFormData(data)
        this.$http.post('/doctor/signature_picture ', fdata, headers).then(
          (res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Assinatura salva com sucesso',
              size: 'md',
              active: true
            })
            this.sending = false
            this.initialImage = true
            this.fn_HIDE_PROGRESS()
          }
        ).catch(
          (err) => {
            console.log(err)
            const errMsg = this.findErrorMessage(err.errors)
            console.log('errMsg', errMsg)
            this.disableCroppa = false
            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: errMsg[0],
              size: 'md',
              active: true
            })
            this.sending = false
            this.fn_HIDE_PROGRESS()
          }
        )
      }, 'image/png', 100)
    },

    findErrorMessage (object) {
      let errorMessage = null
      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }
      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }
      return errorMessage
    }
  }
}
</script>
